import { render, staticRenderFns } from "./DateFilterSelect.vue?vue&type=template&id=b2c442fc&scoped=true"
import script from "./DateFilterSelect.vue?vue&type=script&lang=ts"
export * from "./DateFilterSelect.vue?vue&type=script&lang=ts"
import style0 from "./DateFilterSelect.vue?vue&type=style&index=0&id=b2c442fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c442fc",
  null
  
)

export default component.exports